import React, { ReactNode } from 'react'
import styles from './infoPanel.module.scss'
import { InnerPanel } from 'components/generic/containers/Panels'
import classNames from 'classnames'
import { CommonContainerProps } from 'types/utilities'

interface Props extends Omit<CommonContainerProps, 'children'> {
  title?: string
  info?: ReactNode
  icon?: ReactNode
}

const InfoPanel = ({ title, info, icon, className = '', as }: Props) => {
  return (
    <InnerPanel as={as} className={classNames(styles.infoPanel, className)}>
      {icon}
      {title && (
        <p>
          <em>{title}</em>
        </p>
      )}
      {typeof info === 'string' ? <p>{info}</p> : info}
    </InnerPanel>
  )
}

export default InfoPanel
